module.exports = function (e) {
  var r = {};

  function t(u) {
    if (r[u]) return r[u].exports;
    var n = r[u] = {
      i: u,
      l: !1,
      exports: {}
    };
    return e[u].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  return t.m = e, t.c = r, t.d = function (e, r, u) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: u
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var u = Object.create(null);
    if (t.r(u), Object.defineProperty(u, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var n in e) {
      t.d(u, n, function (r) {
        return e[r];
      }.bind(null, n));
    }
    return u;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 2);
}([function (e, r, t) {
  "use strict";

  function u(e) {
    return !(null !== e && 0 !== e && !1 !== e && "" !== e && void 0 !== e && "undefined" !== e && !Number.isNaN(e));
  }

  t.r(r), t.d(r, "default", function () {
    return u;
  });
}, function (e, r, t) {
  "use strict";

  t.r(r);

  var u = function () {
    function e(r) {
      this.queryString = r, this.keyValuePairs = e.parse(this.queryString);
    }

    return e.prototype.all = function () {
      return this.keyValuePairs;
    }, e.prototype.get = function (e, r) {
      var t = this.keyValuePairs.filter(function (r) {
        return r.key === e;
      });

      if (t.length > 0) {
        var u = t.pop();
        if (u) return u.value;
      }

      return arguments.length > 1 ? r : null;
    }, e.parse = function (e) {
      return "?" === e.charAt(0) && (e = e.substr(1)), e.split("&").filter(function (e) {
        return e.length > 0;
      }).map(function (e) {
        var r,
            t = {
          key: "",
          value: ""
        };
        return r = e.split("="), t.key = r[0], t.value = r[1] || "", t;
      });
    }, e;
  }();

  r.default = u;
}, function (e, r, t) {
  "use strict";

  t.r(r);

  var u = t(1),
      n = t(0),
      i = function () {
    function e(e) {
      this.keyValuePairs = [], this.builtQueryString = "", this.queryStringConfig = e, this.overrideQueryString = "", this.overrideKeyValuePairs = [];
    }

    return e.prototype.withOverrides = function (e) {
      return this.overrideQueryString = e, this.overrideKeyValuePairs = u.default.parse(this.overrideQueryString), this;
    }, e.prototype.getString = function () {
      return this.builtQueryString;
    }, e.prototype.getKeyValuePairs = function () {
      return this.keyValuePairs;
    }, e.prototype.build = function () {
      var r = this;
      return this.queryStringConfig.forEach(function (e) {
        var t = r.createKeyValuePair(e);
        t && r.keyValuePairs.push(t);
      }), this.builtQueryString = e.createQueryString(this.keyValuePairs), this;
    }, e.createQueryString = function (e) {
      return e.reduce(function (e, r) {
        return r.value ? e + (r.key + "=") + r.value + "&" : e + (r.key + "&");
      }, "?").slice(0, -1);
    }, e.prototype.createKeyValuePair = function (e) {
      var r = {
        primary: !0,
        default: !1
      };
      "boolean" == typeof e.excludeIfFalsy ? (r.primary = e.excludeIfFalsy, r.default = e.excludeIfFalsy) : r = Object.assign(r, e.excludeIfFalsy);
      var t = e.override || null,
          u = e.key,
          i = e.primary,
          a = e.default,
          o = !1,
          l = {
        key: u,
        value: ""
      };
      return t && this.overrideKeyValuePairs.forEach(function (e) {
        e.key.match(t) && (l.value = e.value, o = !0);
      }), o || (r.primary && Object(n.default)(i) ? i = !1 : (i = void 0 !== i ? String(i) : "", l.value = i, i = !0)), o || i || (r.default && Object(n.default)(a) ? a = !1 : (a = void 0 !== a ? String(a) : "", l.value = a, a = !0)), o || i || a ? l : null;
    }, e;
  }();

  r.default = i;
}]);